import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _cloneDeep from "lodash/cloneDeep";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.array.filter.js";
import { EXPERIMENTS_METADATA_DELETE } from 'redux/actionTypes/experiments';
import { SAMPLES_METADATA_DELETE } from 'redux/actionTypes/samples';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { metadataNameToKey } from 'utils/data-management/metadataUtils';
var deleteMetadataTrack = function deleteMetadataTrack(name, experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var experiment, metadataKey, newExperiment;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            experiment = getState().experiments[experimentId];
            metadataKey = metadataNameToKey(name);
            newExperiment = _cloneDeep(experiment);
            newExperiment.metadataKeys = experiment.metadataKeys.filter(function (key) {
              return key !== metadataKey;
            });
            _context.prev = 4;
            _context.next = 7;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/metadataTracks/").concat(metadataKey), {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 7:
            dispatch({
              type: EXPERIMENTS_METADATA_DELETE,
              payload: {
                key: metadataKey,
                experimentId: experimentId
              }
            });
            experiment.sampleIds.forEach(function (sampleUuid) {
              return dispatch({
                type: SAMPLES_METADATA_DELETE,
                payload: {
                  sampleUuid: sampleUuid,
                  metadataKey: metadataKey
                }
              });
            });
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            handleError(_context.t0, endUserMessages.ERROR_SAVING);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteMetadataTrack;